import axios from "./_axios";
import { API } from "./apiEndPoints";

export const getListOfCurrencies = async () => {
  let result = await axios()({
    method: "get",
    url: `${API.CURRENCY}`,
    params: { page: 1, size: 500 },
  });
  return result;
};

export const updateOperatingCurrency = async (account_id, id, data) => {
  let result = await axios()({
    method: "put",
    url: `${API.ACCOUNTList}${account_id}/operating-currency/${id}/`,
    data: data,
  });
  return result;
};

export const updateReferenceCurrency = async (user_id, id, data) => {
  let result = await axios()({
    method: "patch",
    url: `${API.COMMON_V1}user/${user_id}/account/${id}/`,
    data: data,
  });
  return result;
};
